import * as React from "react";
import { translate } from "react-i18next";
import { TopBarContainer } from "../../TopBar/TopBar";
import { IKeypadDesktop } from "./KeypadDesktop";
import { KeypadDesktopDefaultView } from "./KeypadDesktop.Default.view";
import { KeypadDesktopMinimalView } from "./KeypadDesktop.Minimal.view";
import { DisplayMode } from "../../../../api/api";

const KeypadDesktopComponentView = (props: IKeypadDesktop) => {
  let View;
  const { displayMode } = props;

  if (displayMode === DisplayMode.TOPBAR) {
    View = TopBarContainer;
  } else if (displayMode === DisplayMode.MINIMAL) {
    View = KeypadDesktopMinimalView;
  } else {
    View = KeypadDesktopDefaultView;
  }

  return <View {...props} />;
};

export const KeypadDesktopView: any = translate("keypad")(
  KeypadDesktopComponentView
);
